import React from 'react';
import styles from './index.module.scss';

export default function Screen2() {
  return (
    <section className={styles['screen2-cover']}>
      <div className={styles['screen2-wrap']}>
        <div className={styles['screen2-title']}>招聘信息</div>

        <div className={styles['screen2-flex']}>
          <div className={styles['screen2-card']}>
            <div
              className={styles['screen2-badge']}
              onClick={() =>
                window.open(
                  'https://app135149.dingtalkoxm.com/social-recruitment/yaww/100004461?locale=zh-CN#/',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              <div className={styles['screen2-badge-text']}>社会招聘</div>
              <div className={styles['screen2-badge-text-sub']}>SHEHUIZHAOPIN</div>
            </div>
          </div>

          <div className={styles['screen2-card']}>
            <div
              className={styles['screen2-badge']}
              onClick={() =>
                window.open(
                  'https://app135149.dingtalkoxm.com/campus-recruitment/yaww/100000446?locale=zh-CN#/',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              <div className={styles['screen2-badge-text']}>校园招聘</div>
              <div className={styles['screen2-badge-text-sub']}>XIAOYUANZHAOPIN</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
